/**
 * Relative timestamps for document lists. `Intl.RelativeTimeFormat` is in every
 * target browser and in jsdom, so there is no date library here: a list only
 * ever needs "3 days ago", and the absolute instant goes in the `title`.
 */

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 3600_000],
  ["month", 30 * 24 * 3600_000],
  ["week", 7 * 24 * 3600_000],
  ["day", 24 * 3600_000],
  ["hour", 3600_000],
  ["minute", 60_000],
];

export function formatRelativeTime(iso: string | null | undefined, now = Date.now()): string {
  if (iso === null || iso === undefined || iso === "") return "";
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return "";

  const elapsed = now - then;
  const formatter = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (const [unit, size] of UNITS) {
    if (Math.abs(elapsed) >= size) {
      return formatter.format(-Math.round(elapsed / size), unit);
    }
  }
  return formatter.format(0, "second");
}

export function formatAbsoluteTime(iso: string | null | undefined): string {
  if (iso === null || iso === undefined || iso === "") return "";
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? "" : parsed.toLocaleString();
}
